import { AdhocHoldOfCntrEntity, EMPTY_ADHOC_HOLD_OF_CNTR_ENTITY } from "domain/entity/AdhocHoldOfContainer/AdhocHoldOfCntrEntity";
import { AdhocHoldOfCntrSearchCriteria, EMPTY_ADHOC_HOLD_OF_CNTR_SEARCH_CRITERIA } from "domain/entity/AdhocHoldOfContainer/AdhocHoldOfCntrSearchCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface AdhocHoldOfCntrModelDropdownOptions {
    // consortiumCodeDropdownOptions: DropdownProps[],
    reasonCodeDropdownOptions: DropdownProps[],
}
export interface AdhocHoldOfCntrModelViewChangeState extends BaseViewChangeSate {
}

export interface AdhocHoldOfCntrModel {
    isLoading: boolean,
    isShowReasonPanel: boolean,
    isShowSearchPanel: boolean,
    dynamicOptions: AdhocHoldOfCntrModelDropdownOptions,
    adhocHoldDataList: AdhocHoldOfCntrEntity[],
    selectedRows: AdhocHoldOfCntrEntity[],
    currentRow: AdhocHoldOfCntrEntity,
    currentEditRow: AdhocHoldOfCntrEntity,
    searchCriteria: AdhocHoldOfCntrSearchCriteria,
    forceRefresh: boolean,
    isShowCancelPad: boolean,
    reasonCode: string,
    isCancel: boolean,
    isSearchLoading: boolean,
}

export const EMPTY_ADHOC_HOLD_OF_CNTR_MODEL: AdhocHoldOfCntrModel = {
    isLoading: false,
    isShowReasonPanel: false,
    isShowSearchPanel: false,
    dynamicOptions: {
        // consortiumCodeDropdownOptions: [],
        reasonCodeDropdownOptions: [],
    },
    adhocHoldDataList: [],
    selectedRows: [],
    currentRow: { ...EMPTY_ADHOC_HOLD_OF_CNTR_ENTITY },
    currentEditRow: { ...EMPTY_ADHOC_HOLD_OF_CNTR_ENTITY },
    searchCriteria: { ...EMPTY_ADHOC_HOLD_OF_CNTR_SEARCH_CRITERIA },
    forceRefresh: false,
    isShowCancelPad: false,
    reasonCode: '',
    isCancel: false,
    isSearchLoading: true,
}